import { capitalize } from 'lodash';
import moment from 'moment';

import { PaymentMethod, Pricing } from './types';

// Calculates current year, list of years and list of months
export const year = new Date().getFullYear();
export const years = Array.from(new Array(21), (val, index) => index + year);
export const months = Array.from(Array(12).keys(), (val, index) => index + 1);

// Calculates the expiration date based on duration days and duration months
export const calculateExpirationDate = (days, months) => {
  return moment().add(days, 'd').add(months, 'M').format('LL');
};

// Calculates subtotal price
export const calculateSubtotal = (price, ammount) => {
  return price * ammount;
};

// Sums prices
export const calculateSum = (arr) => {
  return arr.reduce((sum, x) => sum + x);
};

// Calculates price of each installment
export const calculateInstallmentsPrice = (price) => {
  return price / 4;
};

// Calculates installments payment date
export const calculateInstallmentsDates = (interval: 'week' | 'month', intervalCount: number) => {
  const dates = [
    'today',
    moment().add(intervalCount, interval).format('MM/DD'),
    moment().add(intervalCount * 2, interval).format('MM/DD'),
    moment().add(intervalCount * 3, interval).format('MM/DD')
  ];

  return dates;
};

export const isPaidOrder = (pricing: Pricing) => {
 return pricing.total > 0;
};

export const isPaidCardOrder = (pricing: Pricing, paymentMethod: PaymentMethod) => {
  if (paymentMethod !== PaymentMethod.CREDITCARD && paymentMethod !== PaymentMethod.STRIPE) {
    return false;
  }
  return isPaidOrder(pricing);
};

export const shouldValidatePaymentInfo = (pricing, paymentMethod, schema) => {
  if (isPaidCardOrder(pricing, paymentMethod)) {
    return schema.required();
  } else {
    return schema.optional();
  }
};
